import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { ServicePolicy } from 'views/service-policy'

const ServicePolicyPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'servicepolicy.meta.title' })}
        description={formatMessage({ id: 'servicepolicy.meta.description' })}
      />
      <Header />
      <ServicePolicy />
      <Footer />
    </>
  )
}

export default ServicePolicyPage
